import * as React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const IlluminateCacheFieldSet = ({ config }, ref) => {
  const { t } = useTranslation("enterprise_lookup");
  return /* @__PURE__ */ React.createElement("fieldset", { ref }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      name: "max_size",
      value: config.max_size,
      label: t("illuminate_cache_field_set.max_entries"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      name: "expire_after_access",
      value: `${config.expire_after_access} ${config.expire_after_access_unit}`,
      label: t("illuminate_cache_field_set.expire_after_access"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      name: "expire_after_write",
      value: `${config.expire_after_write} ${config.expire_after_write}`,
      label: t("illuminate_cache_field_set.expire_after_write"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "ignore_null",
      name: "ignore_null",
      label: t("illuminate_cache_field_set.ignore_empty_results"),
      checked: config.ignore_null,
      wrapperClassName: "col-md-offset-3 col-md-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      name: "ttl_empty_unit",
      value: `${config.ttl_empty} ${config.ttl_empty_unit}`,
      label: t("illuminate_cache_field_set.ttl_empty_results"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ));
};
export default IlluminateCacheFieldSet;
